import { axiosInstance } from 'boot/axios.js'

export async function updateDealer(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/users',
      method: 'PUT',
      data: queryParams
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}
